import React, { useEffect } from 'react';

const MARKETING_URL = process.env.REACT_APP_MARKETING_URL || '';

/**
 * Privacy Policy now lives on the main marketing site (bikendure.com/privacy).
 * This page redirects there immediately. The Vercel config also issues a 301
 * for direct navigation, so this only runs when reached via React Router.
 */
const PrivacyPage: React.FC = () => {
  useEffect(() => {
    const target = MARKETING_URL ? `${MARKETING_URL}/privacy` : '/';
    window.location.replace(target);
  }, []);

  return null;
};

export default PrivacyPage;
